(function () {
  var phoneModels = {
    apple: [
      "iPhone 16 Pro Max",
    ],
    samsung: [],
    google: [],
  };

  function initPhoneProduct(root) {
    var grid = root.querySelector("[data-mm-model-grid]");
    if (!grid) return;

    var search = root.querySelector("[data-mm-model-search]");
    var clear = root.querySelector("[data-mm-model-clear]");
    var price = root.querySelector("[data-mm-price]");
    var summary = root.querySelector("[data-mm-selected]");
    var customize = root.querySelector("[data-mm-customize]");
    var caseProperty = root.querySelector("[data-mm-case-property]");
    var modelProperty = root.querySelector("[data-mm-model-property]");
    var activeBrand = "apple";
    var selectedModel = "iPhone 16 Pro Max";

    function selectedCase() {
      return root.querySelector('input[name="mm-case-type"]:checked');
    }

    function updateSummary() {
      var caseInput = selectedCase();
      var caseType = caseInput ? caseInput.value : "Clear Soft Case";
      var casePrice = caseInput ? caseInput.getAttribute("data-price") : "$34.99";
      if (price) price.textContent = casePrice;
      if (summary) summary.textContent = caseType + " · " + selectedModel;
      if (caseProperty) caseProperty.value = caseType;
      if (modelProperty) modelProperty.value = selectedModel;
      if (customize) {
        var url = new URL(customize.getAttribute("data-studio-url"), window.location.origin);
        url.searchParams.set("case", caseType);
        url.searchParams.set("model", selectedModel);
        url.searchParams.set("price", casePrice);
        customize.href = url.pathname + url.search;
      }
    }

    function renderModels() {
      var query = search && search.value ? search.value.trim().toLowerCase() : "";
      var list = phoneModels[activeBrand].filter(function (model) {
        return model.toLowerCase().indexOf(query) !== -1;
      });
      grid.innerHTML = "";
      list.forEach(function (model) {
        var label = document.createElement("label");
        var input = document.createElement("input");
        var span = document.createElement("span");
        input.type = "radio";
        input.name = "mm-phone-model";
        input.value = model;
        input.checked = model === selectedModel;
        span.textContent = model;
        input.addEventListener("change", function () {
          selectedModel = model;
          updateSummary();
        });
        label.appendChild(input);
        label.appendChild(span);
        grid.appendChild(label);
      });
    }

    root.querySelectorAll('input[name="mm-case-type"]').forEach(function (input) {
      input.addEventListener("change", function () {
        root.querySelectorAll("[data-mm-case-card]").forEach(function (card) {
          card.classList.toggle("is-selected", card.contains(input));
        });
        updateSummary();
      });
    });

    root.querySelectorAll("[data-mm-brand]").forEach(function (tab) {
      tab.addEventListener("click", function () {
        activeBrand = tab.getAttribute("data-mm-brand") || "apple";
        if (!phoneModels[activeBrand] || !phoneModels[activeBrand].length) {
          activeBrand = "apple";
        }
        selectedModel = phoneModels[activeBrand][0];
        root.querySelectorAll("[data-mm-brand]").forEach(function (item) {
          item.classList.toggle("is-active", item.getAttribute("data-mm-brand") === activeBrand);
        });
        renderModels();
        updateSummary();
      });
    });

    if (search) search.addEventListener("input", renderModels);
    if (clear) {
      clear.addEventListener("click", function () {
        if (search) search.value = "";
        renderModels();
      });
    }

    renderModels();
    updateSummary();
  }

  function initStudio(root) {
    document.body.classList.add("mm-studio-page");
    var params = new URLSearchParams(window.location.search);
    var caseType = params.get("case") || "Clear Soft Case";
    var model = params.get("model") || "iPhone 16 Pro Max";
    var price = params.get("price") || "$34.99";
    var recipeApiOverride = (params.get("mm_api") || params.get("mm_recipe_api_url") || "").trim();
    var surface = root.querySelector("[data-mm-editor-surface]");
    var device = root.querySelector("[data-mm-device]");
    var modelSelect = root.querySelector("[data-mm-studio-model]");
    var photoInput = root.querySelector("[data-mm-studio-photo]");
    var layerList = root.querySelector("[data-mm-layer-list]");
    var templateLabel = root.querySelector("[data-mm-template-label]");
    var styleSummary = root.querySelector("[data-mm-style-summary]");
    var selectedCopy = root.querySelector("[data-mm-selected-layer-copy]");
    var textInput = root.querySelector("[data-mm-layer-text]");
    var scaleInput = root.querySelector("[data-mm-layer-scale]");
    var rotateInput = root.querySelector("[data-mm-layer-rotate]");
    var designIdEl = root.querySelector("[data-mm-design-id]");
    var note = root.querySelector("[data-mm-studio-note]");
    var addCart = root.querySelector("[data-mm-add-design-cart]");
    var apiCopy = root.querySelector("[data-mm-api-copy]");
    var photoAssetCopy = root.querySelector("[data-mm-photo-asset-copy]");
    var aiJobCopy = root.querySelector("[data-mm-ai-job-copy]");
    var layerSeed = 0;
    var dragState = null;
    var activeModelSpec = null;
    var assetCache = {};
    var undoStack = [];
    var redoStack = [];
    var maxHistory = 50;
    var draftKey = "musemadeStudioDraft:v1";
    var modelSpecs = {
      "iphone 16 pro max": { ratio: 785 / 1593, supplierW: 987, supplierH: 1996, width: "36rem", radius: "4.4rem", caseRadius: "3.8rem", camera: "iphone-pro", cameraLeft: "2.2%", cameraTop: "2.0%", cameraWidth: "52%", safeX: "4.8%", safeY: "4.0%", keepoutLeft: "1.9%", keepoutTop: "1.4%", keepoutWidth: "54%", keepoutHeight: "26%" },
      "iphone 16 pro": { ratio: 71.5 / 149.6, supplierW: 915, supplierH: 1838, width: "33rem", radius: "4.1rem", caseRadius: "3.4rem", camera: "iphone-pro", cameraLeft: "3.7%", cameraTop: "2.9%", cameraWidth: "38%", safeX: "5.6%", safeY: "4.8%", keepoutLeft: "1.8%", keepoutTop: "1.7%", keepoutWidth: "45%", keepoutHeight: "22%" },
      "iphone 15 pro max": { ratio: 76.7 / 159.9, supplierW: 977, supplierH: 1959, width: "35.4rem", radius: "4.4rem", caseRadius: "3.6rem", camera: "iphone-pro", cameraLeft: "3.5%", cameraTop: "2.8%", cameraWidth: "38.5%", safeX: "5.4%", safeY: "4.7%", keepoutLeft: "1.8%", keepoutTop: "1.6%", keepoutWidth: "45.5%", keepoutHeight: "22.5%" },
      "iphone 15 pro": { ratio: 70.6 / 146.6, supplierW: 905, supplierH: 1802, width: "32.7rem", radius: "4rem", caseRadius: "3.3rem", camera: "iphone-pro", cameraLeft: "3.8%", cameraTop: "3%", cameraWidth: "38%", safeX: "5.6%", safeY: "4.9%", keepoutLeft: "1.9%", keepoutTop: "1.8%", keepoutWidth: "45%", keepoutHeight: "22.5%" },
      "iphone 14 pro max": { ratio: 77.6 / 160.7, supplierW: 987, supplierH: 1969, width: "35.6rem", radius: "4.4rem", caseRadius: "3.6rem", camera: "iphone-pro", cameraLeft: "3.5%", cameraTop: "2.8%", cameraWidth: "38.5%", safeX: "5.4%", safeY: "4.7%", keepoutLeft: "1.8%", keepoutTop: "1.7%", keepoutWidth: "45.5%", keepoutHeight: "22.5%" },
      "iphone 14 pro": { ratio: 71.5 / 147.5, supplierW: 915, supplierH: 1813, width: "32.9rem", radius: "4rem", caseRadius: "3.3rem", camera: "iphone-pro", cameraLeft: "3.8%", cameraTop: "3%", cameraWidth: "38%", safeX: "5.6%", safeY: "4.9%", keepoutLeft: "1.9%", keepoutTop: "1.8%", keepoutWidth: "45%", keepoutHeight: "22.5%" },
      "galaxy s25 ultra": { ratio: 77.6 / 162.8, supplierW: 987, supplierH: 1994, width: "35.7rem", radius: "2.5rem", caseRadius: "2rem", camera: "samsung-ultra", cameraLeft: "6.4%", cameraTop: "5.2%", cameraWidth: "33%", safeX: "5%", safeY: "4.4%", keepoutLeft: "3.2%", keepoutTop: "3.2%", keepoutWidth: "30%", keepoutHeight: "24%" },
      "galaxy s24 ultra": { ratio: 79 / 162.3, supplierW: 1004, supplierH: 1988, width: "36.2rem", radius: "2.4rem", caseRadius: "1.9rem", camera: "samsung-ultra", cameraLeft: "6.4%", cameraTop: "5.2%", cameraWidth: "33%", safeX: "5%", safeY: "4.4%", keepoutLeft: "3.2%", keepoutTop: "3.2%", keepoutWidth: "30%", keepoutHeight: "24%" },
    };

    var templates = {
      "kawaii-collage": {
        label: "Kawaii collage",
        layers: [
          { type: "shape", name: "Pink record", shape: "record", x: 50, y: 47, w: 54, h: 29, scale: 1, rotate: -3 },
          { type: "photo", name: "Top cutout", crop: "cutout", x: 72, y: 28, w: 24, h: 19, scale: 1, rotate: 4 },
          { type: "photo", name: "Circle portrait", crop: "circle", x: 50, y: 49, w: 33, h: 20, scale: 1, rotate: 0 },
          { type: "text", name: "Name script", text: "Rawteeen", x: 64, y: 39, w: 30, h: 7, scale: 0.76, rotate: 4 },
          { type: "sticker", name: "Bear sticker", sticker: "bear", x: 23, y: 39, w: 12, h: 10, scale: 1, rotate: -12 },
          { type: "sticker", name: "Sparkles", sticker: "sparkle", x: 80, y: 57, w: 12, h: 13, scale: 1, rotate: 0 },
          { type: "sticker", name: "Strawberry", sticker: "strawberry", x: 23, y: 68, w: 16, h: 15, scale: 1, rotate: -8 },
          { type: "sticker", name: "Heart badge", sticker: "heart", x: 65, y: 73, w: 21, h: 16, scale: 1, rotate: 8 },
          { type: "photo", name: "Bottom left cutout", crop: "cutout", x: 31, y: 82, w: 29, h: 20, scale: 1, rotate: -3 },
          { type: "photo", name: "Bottom right cutout", crop: "cutout", x: 65, y: 83, w: 29, h: 18, scale: 1, rotate: 10 },
        ],
      },
      "poster-pop": {
        label: "Poster pop",
        layers: [
          { type: "shape", name: "Sunset block", shape: "poster", x: 50, y: 48, w: 74, h: 62, scale: 1, rotate: 0 },
          { type: "photo", name: "Hero cutout", crop: "cutout", x: 51, y: 39, w: 52, h: 43, scale: 1, rotate: -2 },
          { type: "text", name: "Bold name", text: "MILO", x: 50, y: 72, w: 52, h: 13, scale: 1, rotate: -2 },
          { type: "sticker", name: "Sparkles", sticker: "sparkle", x: 79, y: 24, w: 18, h: 19, scale: 1, rotate: 0 },
          { type: "sticker", name: "Heart badge", sticker: "heart", x: 25, y: 77, w: 22, h: 18, scale: 1, rotate: -12 },
        ],
      },
      "clean-frame": {
        label: "Clean frame",
        layers: [
          { type: "shape", name: "Soft frame", shape: "frame", x: 50, y: 51, w: 68, h: 64, scale: 1, rotate: 0 },
          { type: "photo", name: "Main portrait", crop: "circle", x: 50, y: 45, w: 50, h: 36, scale: 1, rotate: 0 },
          { type: "text", name: "Small caption", text: "forever favorite", x: 50, y: 76, w: 55, h: 8, scale: 1, rotate: 0 },
          { type: "sticker", name: "Sparkles", sticker: "sparkle", x: 76, y: 31, w: 13, h: 14, scale: 1, rotate: 0 },
        ],
      },
    };

    var designState = {
      id: "",
      path: "pet",
      pathVersion: "pet@1.0",
      caseType: caseType,
      model: model,
      price: price,
      template: "kawaii-collage",
      photoName: "",
      photoData: "",
      photoAsset: null,
      supplierArtworkAsset: null,
      pendingAiAsset: null,
      selectedId: "",
      layers: [],
    };

    function copyState() {
      return JSON.parse(JSON.stringify({
        layerSeed: layerSeed,
        designState: designState,
      }));
    }

    function snapshotString() {
      return JSON.stringify(copyState());
    }

    function applySnapshot(snapshot) {
      var next = typeof snapshot === "string" ? JSON.parse(snapshot) : snapshot;
      if (!next || !next.designState) return false;
      Object.keys(designState).forEach(function (key) {
        delete designState[key];
      });
      Object.assign(designState, next.designState);
      layerSeed = Number(next.layerSeed || 0);
      applyModelSpec(designState.model);
      return true;
    }

    function persistDraft() {
      try {
        window.localStorage.setItem(draftKey, snapshotString());
      } catch (error) {
        root.setAttribute("data-mm-draft-storage", "failed");
      }
    }

    function pushHistory() {
      var snapshot = snapshotString();
      if (undoStack[undoStack.length - 1] === snapshot) {
        persistDraft();
        updateHistoryButtons();
        return;
      }
      undoStack.push(snapshot);
      if (undoStack.length > maxHistory) undoStack.shift();
      redoStack = [];
      persistDraft();
      updateHistoryButtons();
    }

    function resetHistory() {
      undoStack = [snapshotString()];
      redoStack = [];
      persistDraft();
      updateHistoryButtons();
    }

    function restoreDraft() {
      try {
        var saved = window.localStorage.getItem(draftKey);
        if (!saved) return false;
        if (!applySnapshot(saved)) return false;
        root.setAttribute("data-mm-draft-restored", "true");
        return true;
      } catch (error) {
        root.setAttribute("data-mm-draft-restored", "failed");
        return false;
      }
    }

    function updateHistoryButtons() {
      root.querySelectorAll("[data-mm-undo-layer]").forEach(function (button) {
        button.disabled = undoStack.length <= 1;
      });
      root.querySelectorAll("[data-mm-redo-layer]").forEach(function (button) {
        button.disabled = redoStack.length < 1;
      });
    }

    function undoChange() {
      if (undoStack.length <= 1) return;
      redoStack.push(undoStack.pop());
      applySnapshot(undoStack[undoStack.length - 1]);
      persistDraft();
      renderAll();
      updateHistoryButtons();
      setNote("Undo applied. Your draft is still saved in this browser.", "success");
    }

    function redoChange() {
      if (!redoStack.length) return;
      var snapshot = redoStack.pop();
      undoStack.push(snapshot);
      applySnapshot(snapshot);
      persistDraft();
      renderAll();
      updateHistoryButtons();
      setNote("Redo applied. Your draft is still saved in this browser.", "success");
    }

    root.querySelectorAll("[data-mm-case-summary]").forEach(function (el) {
      el.textContent = caseType;
    });
    function syncModelText() {
      root.querySelectorAll("[data-mm-model-summary]").forEach(function (el) {
        el.textContent = designState.model;
      });
      root.querySelectorAll("[data-mm-spec-summary]").forEach(function (el) {
        el.textContent = designState.caseType + " · " + designState.model;
      });
    }

    function syncSupplierArtworkText() {
      var size = supplierArtworkCanvas();
      root.querySelectorAll("[data-mm-supplier-size-summary]").forEach(function (el) {
        el.textContent = size.w + " x " + size.h + "px";
      });
    }

    function applyModelSpec(nextModel) {
      designState.model = nextModel || designState.model;
      if (modelSelect && modelSelect.value !== designState.model) modelSelect.value = designState.model;
      syncModelText();
      if (!device) return;
      var model = designState.model;
      var specKey = model.trim().toLowerCase().replace(/\s+/g, " ");
      var spec = modelSpecs[specKey] || {
        ratio: /samsung|galaxy/i.test(model) ? 0.48 : 0.478,
        width: /max|ultra|plus/i.test(model) ? "35.5rem" : "33rem",
        radius: /samsung|galaxy/i.test(model) ? "2.6rem" : "4rem",
        caseRadius: /samsung|galaxy/i.test(model) ? "2.1rem" : "3.3rem",
        camera: /samsung|galaxy/i.test(model) ? "samsung-ultra" : "iphone-pro",
        cameraLeft: /samsung|galaxy/i.test(model) ? "6.4%" : "3.7%",
        cameraTop: /samsung|galaxy/i.test(model) ? "5.2%" : "2.9%",
        cameraWidth: /samsung|galaxy/i.test(model) ? "33%" : "38%",
        safeX: /samsung|galaxy/i.test(model) ? "5%" : "5.5%",
        safeY: /samsung|galaxy/i.test(model) ? "4.4%" : "4.8%",
        keepoutLeft: /samsung|galaxy/i.test(model) ? "3.2%" : "1.8%",
        keepoutTop: /samsung|galaxy/i.test(model) ? "3.2%" : "1.7%",
        keepoutWidth: /samsung|galaxy/i.test(model) ? "30%" : "45%",
        keepoutHeight: /samsung|galaxy/i.test(model) ? "24%" : "22.5%",
      };
      activeModelSpec = spec;
      device.setAttribute("data-model-size", /max|ultra|plus/i.test(model) ? "large" : "standard");
      device.setAttribute("data-camera", spec.camera);
      device.style.setProperty("--mm-model-ratio", spec.ratio);
      device.style.setProperty("--mm-model-width", spec.width);
      device.style.setProperty("--mm-model-radius", spec.radius);
      device.style.setProperty("--mm-case-radius", spec.caseRadius);
      device.style.setProperty("--mm-camera-left", spec.cameraLeft);
      device.style.setProperty("--mm-camera-top", spec.cameraTop);
      device.style.setProperty("--mm-camera-width", spec.cameraWidth);
      device.style.setProperty("--mm-safe-inset-x", spec.safeX);
      device.style.setProperty("--mm-safe-inset-y", spec.safeY);
      device.style.setProperty("--mm-keepout-left", spec.keepoutLeft);
      device.style.setProperty("--mm-keepout-top", spec.keepoutTop);
      device.style.setProperty("--mm-keepout-width", spec.keepoutWidth);
      device.style.setProperty("--mm-keepout-height", spec.keepoutHeight);
      syncSupplierArtworkText();
    }

    function setNote(text, tone) {
      if (!note) return;
      note.textContent = text;
      note.setAttribute("data-tone", tone || "info");
    }

    function shortId(value) {
      value = String(value || "");
      return value.length > 18 ? value.slice(0, 8) + "..." + value.slice(-6) : value;
    }

    function syncAssetControls() {
      var hasApi = !!recipeApiUrl();
      var apiSource = recipeApiSource();
      var apiMode = hasApi ? apiSource : "local";
      var photoAsset = designState.photoAsset;
      var pendingAi = designState.pendingAiAsset;
      var photoStatus = root.getAttribute("data-mm-photo-asset-status") || (photoAsset && photoAsset.status) || "";
      var aiStatus = root.getAttribute("data-mm-ai-job-status") || (pendingAi && pendingAi.status) || "idle";
      root.setAttribute("data-mm-api-mode", apiMode);
      root.setAttribute("data-mm-api-endpoint", recipeApiUrl() || "");
      root.setAttribute("data-mm-recipe-api-source", apiSource);
      root.setAttribute("data-mm-recipe-api-active", hasApi ? "true" : "false");
      if (apiCopy) {
        apiCopy.textContent = hasApi
          ? (apiSource === "query" ? "API via query" : "API via theme")
          : "Local only";
      }
      if (photoAssetCopy) {
        photoAssetCopy.textContent = photoAsset && photoAsset.assetId
          ? (photoAsset.status || photoStatus || "ready") + " · " + shortId(photoAsset.assetId)
          : photoStatus === "registering"
            ? "Registering..."
            : "Not uploaded";
      }
      if (aiJobCopy) {
        var jobId = root.getAttribute("data-mm-ai-job-id") || (pendingAi && pendingAi.pipeline && pendingAi.pipeline.jobId) || "";
        aiJobCopy.textContent = pendingAi && pendingAi.assetId
          ? (aiStatus || pendingAi.status || "processing") + " · " + shortId(pendingAi.assetId)
          : aiStatus === "missing-api"
            ? "API URL required"
            : aiStatus === "missing-parent-asset"
              ? "Upload photo first"
              : jobId
                ? (aiStatus + " · " + shortId(jobId))
                : "Idle";
      }
      root.querySelectorAll("[data-mm-ai-action]").forEach(function (button) {
        button.disabled = !hasApi || !photoAsset || photoAsset.status !== "ready" || aiStatus === "requesting" || aiStatus === "refreshing";
      });
      root.querySelectorAll("[data-mm-ai-refresh]").forEach(function (button) {
        button.disabled = !hasApi || !pendingAi || !pendingAi.assetId || aiStatus === "requesting" || aiStatus === "refreshing";
      });
    }

    function makeDesignId() {
      return "MM-" + Date.now().toString(36).toUpperCase();
    }

    function modelTemplateId() {
      return designState.model.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
    }

    function rectFromSpec(prefix, fallback) {
      var spec = activeModelSpec || {};
      if (prefix === "safe") {
        var safeX = percentNumber(spec.safeX, fallback.x);
        var safeY = percentNumber(spec.safeY, fallback.y);
        return { x: safeX, y: safeY, w: 100 - safeX * 2, h: 100 - safeY * 2 };
      }
      return {
        x: percentNumber(spec.keepoutLeft, fallback.x),
        y: percentNumber(spec.keepoutTop, fallback.y),
        w: percentNumber(spec.keepoutWidth, fallback.w),
        h: percentNumber(spec.keepoutHeight, fallback.h),
      };
    }

    function layerRect(layer) {
      var scale = Number(layer.scale || 1);
      var w = Number(layer.w || 0) * scale;
      var h = Number(layer.h || 0) * scale;
      return {
        x: Number(layer.x || 0) - w / 2,
        y: Number(layer.y || 0) - h / 2,
        w: w,
        h: h,
      };
    }

    function rectIntersects(a, b) {
      return a.x < b.x + b.w && a.x + a.w > b.x && a.y < b.y + b.h && a.y + a.h > b.y;
    }

    function rectInside(inner, outer) {
      return inner.x >= outer.x && inner.y >= outer.y && inner.x + inner.w <= outer.x + outer.w && inner.y + inner.h <= outer.y + outer.h;
    }

    function validateDraft() {
      var errors = [];
      var warnings = [];
      var templateId = modelTemplateId();
      var safeArea = rectFromSpec("safe", { x: 5.5, y: 4.8, w: 89, h: 90.4 });
      var cameraKeepout = rectFromSpec("keepout", { x: 1.8, y: 1.7, w: 45, h: 22.5 });
      var printableLayers = designState.layers.filter(function (layer) {
        return ["photo", "shape", "sticker", "text"].includes(layer.type);
      });

      if (!templateId) errors.push("Choose a supported phone model first.");
      if (!designState.caseType) errors.push("Choose a case type before saving.");
      if (!designState.template || !templates[designState.template]) errors.push("Choose a design preset first.");
      if (!printableLayers.length) errors.push("Add at least one editable design layer.");

      designState.layers.forEach(function (layer) {
        var name = layer.name || layer.id || "Layer";
        var rect = layerRect(layer);
        if (!Number.isFinite(rect.x) || !Number.isFinite(rect.y) || rect.w <= 0 || rect.h <= 0) {
          errors.push(name + " has an invalid size.");
          return;
        }
        if (layer.type === "text" && !String(layer.text || "").trim()) {
          errors.push(name + " needs text.");
        }
        if (rectIntersects(rect, cameraKeepout)) {
          errors.push(name + " overlaps the camera area.");
        }
        if (!rectInside(rect, safeArea)) {
          warnings.push(name + " is close to the printable edge.");
        }
      });

      return {
        ok: errors.length === 0,
        errors: errors,
        warnings: warnings,
      };
    }

    function applyValidationSummary(validation) {
      var errors = validation && validation.errors ? validation.errors : [];
      var warnings = validation && validation.warnings ? validation.warnings : [];
      root.setAttribute("data-mm-recipe-valid", errors.length ? "false" : "true");
      root.setAttribute("data-mm-validation-errors", String(errors.length));
      root.setAttribute("data-mm-validation-warnings", String(warnings.length));
      if (!errors.length) return true;
      setNote(errors[0], "error");
      return false;
    }

    function layerToRecipeLayer(layer, resolvedAsset) {
      var layerType = layer.type === "shape" ? "sticker" : layer.type;
      if (layer.type === "photo") layerType = "subject";
      var asset = resolvedAsset || {
        assetId: layer.type + ":" + (layer.sticker || layer.shape || layer.crop || "placeholder"),
        url: layer.type === "photo" ? designState.photoData || "musemade://placeholder/pet-subject" : "musemade://preset/" + designState.template + "/" + (layer.sticker || layer.shape || layer.name),
        hasAlpha: layer.type !== "shape",
      };
      return {
        id: layer.id,
        type: layerType,
        name: layer.name,
        x: layer.x,
        y: layer.y,
        w: layer.w,
        h: layer.h,
        scale: layer.scale || 1,
        rotation: layer.rotate || 0,
        opacity: 1,
        z: layer.z,
        locked: false,
        softLock: layer.type === "photo",
        asset: asset,
        text: layer.type === "text" ? {
          content: layer.text || "Name",
          font: "Fraunces Italic",
          color: "#ef5b91",
          align: "center",
        } : undefined,
        meta: {
          sourceType: layer.type,
          crop: layer.crop || "",
          sticker: layer.sticker || "",
          shape: layer.shape || "",
        },
      };
    }

    function buildDesignRecipe(resolvedAssets) {
      var designId = designState.id || makeDesignId();
      var template = templates[designState.template] || templates["kawaii-collage"];
      var assets = resolvedAssets || {};
      var supplierArtwork = supplierArtworkCanvas();
      return {
        schema: "musemade.design_recipe",
        schemaVersion: "0.1.0",
        designId: designId,
        path: designState.path,
        pathVersion: designState.pathVersion,
        factCardId: designState.photoName ? "local-photo:" + designState.photoName : "placeholder:pet",
        styleIntentId: designState.template,
        createdAt: new Date().toISOString(),
        source: {
          shopifyProduct: "ai-pet-phone-case",
          caseType: designState.caseType,
          price: designState.price,
          photoName: designState.photoName || "",
        },
        canvas: {
          w: 1000,
          h: Math.round(1000 / ((activeModelSpec && activeModelSpec.ratio) || 0.476)),
          unit: "percent-preview",
          phoneModelTemplate: modelTemplateId(),
          phoneModelLabel: designState.model,
          safeArea: rectFromSpec("safe", { x: 5.5, y: 4.8, w: 89, h: 90.4 }),
          cameraKeepout: rectFromSpec("keepout", { x: 1.8, y: 1.7, w: 45, h: 22.5 }),
          bleed: { x: 2, y: 2, w: 96, h: 96 },
        },
        supplierArtwork: {
          format: "png",
          w: supplierArtwork.w,
          h: supplierArtwork.h,
          unit: "px",
          background: "transparent",
          phoneModelTemplate: modelTemplateId(),
          phoneModelLabel: designState.model,
          generatedIn: "browser",
          asset: designState.supplierArtworkAsset || null,
          assetId: designState.supplierArtworkAsset && designState.supplierArtworkAsset.assetId ? designState.supplierArtworkAsset.assetId : "",
          previewUrl: designState.supplierArtworkAsset && designState.supplierArtworkAsset.previewUrl ? designState.supplierArtworkAsset.previewUrl : "",
          printUrl: designState.supplierArtworkAsset && designState.supplierArtworkAsset.printUrl ? designState.supplierArtworkAsset.printUrl : "",
        },
        template: {
          id: designState.template,
          label: template.label,
        },
        layers: designState.layers.slice().sort(function (a, b) { return a.z - b.z; }).map(function (layer) {
          return layerToRecipeLayer(layer, assets[layer.id]);
        }),
      };
    }

    function escapeSvg(value) {
      return String(value ?? "")
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;");
    }

    function svgDataUrl(svg) {
      return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
    }

    function previewLayerSvg(layer, canvas) {
      var x = (Number(layer.x || 0) / 100) * canvas.w;
      var y = (Number(layer.y || 0) / 100) * canvas.h;
      var w = (Number(layer.w || 0) / 100) * canvas.w;
      var h = (Number(layer.h || 0) / 100) * canvas.h;
      var scale = Number(layer.scale || 1);
      var rotation = Number(layer.rotate || 0);
      var common = 'transform="translate(' + x.toFixed(2) + " " + y.toFixed(2) + ") rotate(" + rotation.toFixed(2) + ") scale(" + scale.toFixed(2) + ')"';
      var box = 'x="' + (-w / 2).toFixed(2) + '" y="' + (-h / 2).toFixed(2) + '" width="' + w.toFixed(2) + '" height="' + h.toFixed(2) + '"';

      if (layer.type === "text") {
        return '<g ' + common + '><text x="0" y="0" text-anchor="middle" dominant-baseline="middle" font-family="Georgia, serif" font-size="' + Math.max(18, h * 0.72).toFixed(0) + '" font-style="italic" font-weight="800" fill="#ef5b91" stroke="#242724" stroke-width="2">' + escapeSvg(layer.text || "Name") + "</text></g>";
      }

      if (layer.type === "photo") {
        if (designState.photoData && (designState.photoData.length < 900000 || canvas.w > 800)) {
          return '<g ' + common + '><clipPath id="clip-' + escapeSvg(layer.id) + '"><rect ' + box + ' rx="' + (layer.crop === "circle" ? Math.min(w, h) / 2 : 28) + '"/></clipPath><image href="' + escapeSvg(designState.photoData) + '" ' + box + ' preserveAspectRatio="xMidYMid slice" clip-path="url(#clip-' + escapeSvg(layer.id) + ')"/><rect ' + box + ' rx="' + (layer.crop === "circle" ? Math.min(w, h) / 2 : 28) + '" fill="none" stroke="#3d4442" stroke-width="8"/><rect ' + box + ' rx="' + (layer.crop === "circle" ? Math.min(w, h) / 2 : 28) + '" fill="none" stroke="#cf3f7a" stroke-width="13" opacity=".62" transform="translate(9 9)"/></g>';
        }
        return '<g ' + common + '><rect ' + box + ' rx="28" fill="#c7a879" stroke="#3d4442" stroke-width="8"/><path d="M' + (-w * 0.28).toFixed(1) + " " + (-h * 0.18).toFixed(1) + " C " + (-w * 0.04).toFixed(1) + " " + (-h * 0.34).toFixed(1) + ", " + (w * 0.24).toFixed(1) + " " + (-h * 0.08).toFixed(1) + ", " + (w * 0.08).toFixed(1) + " " + (h * 0.16).toFixed(1) + '" fill="none" stroke="#9b815e" stroke-width="8" opacity=".55"/><circle cx="' + (-w * 0.16).toFixed(1) + '" cy="' + (-h * 0.05).toFixed(1) + '" r="8" fill="#17201d"/><circle cx="' + (w * 0.14).toFixed(1) + '" cy="' + (-h * 0.05).toFixed(1) + '" r="8" fill="#17201d"/><circle cx="0" cy="' + (h * 0.15).toFixed(1) + '" r="10" fill="#a45e3f"/><rect ' + box + ' rx="28" fill="none" stroke="#cf3f7a" stroke-width="13" opacity=".62" transform="translate(9 9)"/></g>';
      }

      if (layer.sticker === "heart") {
        return '<g ' + common + '><path d="M0 ' + (h * 0.32).toFixed(1) + " C " + (-w * 0.5).toFixed(1) + " " + (-h * 0.05).toFixed(1) + ", " + (-w * 0.25).toFixed(1) + " " + (-h * 0.45).toFixed(1) + ", 0 " + (-h * 0.15).toFixed(1) + " C " + (w * 0.25).toFixed(1) + " " + (-h * 0.45).toFixed(1) + ", " + (w * 0.5).toFixed(1) + " " + (-h * 0.05).toFixed(1) + ", 0 " + (h * 0.32).toFixed(1) + '" fill="#f24b2f" stroke="#5986d9" stroke-width="9"/></g>';
      }
      if (layer.sticker === "sparkle") {
        return '<g ' + common + '><path d="M0 ' + (-h / 2).toFixed(1) + " L " + (w * 0.13).toFixed(1) + " " + (-h * 0.08).toFixed(1) + " L " + (w / 2).toFixed(1) + " 0 L " + (w * 0.13).toFixed(1) + " " + (h * 0.08).toFixed(1) + " L 0 " + (h / 2).toFixed(1) + " L " + (-w * 0.13).toFixed(1) + " " + (h * 0.08).toFixed(1) + " L " + (-w / 2).toFixed(1) + " 0 L " + (-w * 0.13).toFixed(1) + " " + (-h * 0.08).toFixed(1) + ' Z" fill="#ffc928"/></g>';
      }
      if (layer.sticker === "strawberry") {
        return '<g ' + common + '><ellipse cx="0" cy="' + (h * 0.08).toFixed(1) + '" rx="' + (w * 0.38).toFixed(1) + '" ry="' + (h * 0.45).toFixed(1) + '" fill="#f75c9b" stroke="#f4a5c4" stroke-width="10"/><path d="M0 ' + (-h * 0.48).toFixed(1) + " L " + (-w * 0.2).toFixed(1) + " " + (-h * 0.22).toFixed(1) + " L 0 " + (-h * 0.28).toFixed(1) + " L " + (w * 0.2).toFixed(1) + " " + (-h * 0.22).toFixed(1) + ' Z" fill="#64c98f"/></g>';
      }
      if (layer.sticker === "bear") {
        return '<g ' + common + '><ellipse cx="0" cy="0" rx="' + (w * 0.34).toFixed(1) + '" ry="' + (h * 0.42).toFixed(1) + '" fill="#d6528f" stroke="#fff" stroke-width="9"/><circle cx="' + (-w * 0.21).toFixed(1) + '" cy="' + (-h * 0.32).toFixed(1) + '" r="' + (Math.min(w, h) * 0.13).toFixed(1) + '" fill="#d6528f" stroke="#fff" stroke-width="7"/><circle cx="' + (w * 0.21).toFixed(1) + '" cy="' + (-h * 0.32).toFixed(1) + '" r="' + (Math.min(w, h) * 0.13).toFixed(1) + '" fill="#d6528f" stroke="#fff" stroke-width="7"/><circle cx="' + (-w * 0.13).toFixed(1) + '" cy="' + (-h * 0.05).toFixed(1) + '" r="7" fill="#26302d"/><circle cx="' + (w * 0.13).toFixed(1) + '" cy="' + (-h * 0.05).toFixed(1) + '" r="7" fill="#26302d"/><circle cx="0" cy="' + (h * 0.16).toFixed(1) + '" r="13" fill="#8d3b5d"/></g>';
      }
      return '<g ' + common + '><ellipse rx="' + (w / 2).toFixed(2) + '" ry="' + (h / 2).toFixed(2) + '" fill="#cf3f7a" opacity=".92"/><ellipse rx="' + (w * 0.34).toFixed(2) + '" ry="' + (h * 0.34).toFixed(2) + '" fill="#f0b2c2"/></g>';
    }

    function buildWatermarkedPreview(recipe) {
      var canvas = { w: 500, h: Math.round(500 / ((activeModelSpec && activeModelSpec.ratio) || 0.476)) };
      var previewLayers = designState.layers
        .slice()
        .sort(function (a, b) { return a.z - b.z; })
        .map(function (layer) {
          return previewLayerSvg(layer, canvas);
        })
        .join("");
      var camera = rectFromSpec("keepout", { x: 1.8, y: 1.7, w: 45, h: 22.5 });
      var cameraRect = {
        x: (camera.x / 100) * canvas.w,
        y: (camera.y / 100) * canvas.h,
        w: (camera.w / 100) * canvas.w,
        h: (camera.h / 100) * canvas.h,
      };
      return '<svg xmlns="http://www.w3.org/2000/svg" width="' + canvas.w + '" height="' + canvas.h + '" viewBox="0 0 ' + canvas.w + " " + canvas.h + '"><defs><pattern id="mm-grid" width="24" height="24" patternUnits="userSpaceOnUse"><rect width="12" height="12" fill="#f5f4f0"/><rect x="12" width="12" height="12" fill="#d7d7d4"/><rect y="12" width="12" height="12" fill="#d7d7d4"/><rect x="12" y="12" width="12" height="12" fill="#f5f4f0"/></pattern></defs><rect width="100%" height="100%" rx="44" fill="url(#mm-grid)"/><rect x="8" y="8" width="' + (canvas.w - 16) + '" height="' + (canvas.h - 16) + '" rx="40" fill="none" stroke="#111815" stroke-width="10"/><rect x="' + cameraRect.x.toFixed(1) + '" y="' + cameraRect.y.toFixed(1) + '" width="' + cameraRect.w.toFixed(1) + '" height="' + cameraRect.h.toFixed(1) + '" rx="24" fill="#161b19" opacity=".92"/>' + previewLayers + '<g opacity=".22" transform="rotate(-35 ' + (canvas.w / 2) + " " + (canvas.h / 2) + ')"><text x="' + (canvas.w / 2) + '" y="' + (canvas.h * 0.46) + '" text-anchor="middle" font-family="Georgia, serif" font-size="46" font-weight="800" fill="#111815">MuseMade Preview</text><text x="' + (canvas.w / 2) + '" y="' + (canvas.h * 0.54) + '" text-anchor="middle" font-family="Arial, sans-serif" font-size="18" font-weight="800" fill="#111815">' + escapeSvg(recipe.designId) + '</text></g><text x="24" y="' + (canvas.h - 26) + '" font-family="Arial, sans-serif" font-size="14" font-weight="800" fill="#111815" opacity=".68">Watermarked low-res preview · not for print</text></svg>';
    }

    function supplierArtworkCanvas() {
      var spec = activeModelSpec || {};
      var ratio = spec.ratio || 0.476;
      var width = Number(spec.supplierW || 0);
      var height = Number(spec.supplierH || 0);
      if (!width || !height) {
        height = 2000;
        width = Math.round(height * ratio);
      }
      return { w: width, h: height };
    }

    function buildSupplierArtworkSvg() {
      var canvas = supplierArtworkCanvas();
      var layers = designState.layers
        .slice()
        .sort(function (a, b) { return a.z - b.z; })
        .map(function (layer) {
          return previewLayerSvg(layer, canvas);
        })
        .join("");
      return '<svg xmlns="http://www.w3.org/2000/svg" width="' + canvas.w + '" height="' + canvas.h + '" viewBox="0 0 ' + canvas.w + " " + canvas.h + '">' + layers + "</svg>";
    }

    function renderSupplierArtworkPngBlob() {
      var svg = buildSupplierArtworkSvg();
      var canvasSize = supplierArtworkCanvas();
      var blob = new Blob([svg], { type: "image/svg+xml;charset=utf-8" });
      var url = URL.createObjectURL(blob);
      var img = new Image();
      return new Promise(function (resolve, reject) {
        img.onload = function () {
          var canvas = document.createElement("canvas");
          canvas.width = canvasSize.w;
          canvas.height = canvasSize.h;
          var context = canvas.getContext("2d");
          context.clearRect(0, 0, canvas.width, canvas.height);
          context.drawImage(img, 0, 0);
          URL.revokeObjectURL(url);
          canvas.toBlob(function (pngBlob) {
            if (!pngBlob) {
              reject(new Error("Supplier PNG render failed"));
              return;
            }
            resolve({ blob: pngBlob, size: canvasSize, dataUrl: canvas.toDataURL("image/png") });
          }, "image/png");
        };
        img.onerror = function () {
          URL.revokeObjectURL(url);
          reject(new Error("Supplier PNG image decode failed"));
        };
        img.src = url;
      });
    }

    function supplierArtworkAssetId(size) {
      if (!designState.id) designState.id = makeDesignId();
      return ("supplier-" + designState.id + "-" + modelTemplateId() + "-" + size.w + "x" + size.h).toLowerCase().replace(/[^a-z0-9_.:-]+/g, "-").slice(0, 110);
    }

    function registerSupplierArtworkAsset(rendered) {
      var url = assetUploadDataUrlApiUrl() || assetRegisterApiUrl();
      if (!url || !rendered || !rendered.dataUrl) return Promise.resolve(null);
      var assetId = supplierArtworkAssetId(rendered.size);
      return fetch(url, {
        method: "POST",
        headers: apiHeaders(),
        body: JSON.stringify({
          allowOverwrite: true,
          sessionId: studioSessionId(),
          dataUrl: rendered.dataUrl,
          fileName: assetId + ".png",
          asset: {
            id: assetId,
            sessionId: studioSessionId(),
            path: designState.path,
            pathVersion: designState.pathVersion,
            kind: "supplier_artwork",
            scope: "production",
            source: "studio-supplier-export",
            status: "ready",
            hasAlpha: true,
            width: rendered.size.w,
            height: rendered.size.h,
            meta: {
              source: "studio-supplier-export",
              designId: designState.id,
              caseType: designState.caseType,
              phoneModel: designState.model,
              phoneModelTemplate: modelTemplateId(),
              template: designState.template,
              note: "Transparent supplier artwork PNG generated in MuseMade Studio.",
            },
          },
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Supplier artwork upload failed");
          return response.json();
        })
        .then(function (payload) {
          var normalized = normalizeAssetForRecipe(payload && payload.asset);
          if (!normalized) throw new Error("Missing supplier artwork asset payload");
          designState.supplierArtworkAsset = normalized;
          root.setAttribute("data-mm-supplier-artwork-asset-id", normalized.assetId || "");
          return normalized;
        });
    }

    function downloadSupplierArtworkBlob(rendered, recipe) {
      var objectUrl = URL.createObjectURL(rendered.blob);
      var link = document.createElement("a");
      link.href = objectUrl;
      link.download = (recipe && recipe.designId ? recipe.designId : designState.id || "musemade-design") + "-" + modelTemplateId() + "-supplier-" + rendered.size.w + "x" + rendered.size.h + ".png";
      document.body.appendChild(link);
      link.click();
      link.remove();
      setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 1000);
    }

    function exportSupplierArtworkPng(recipe) {
      return renderSupplierArtworkPngBlob().then(function (rendered) {
        downloadSupplierArtworkBlob(rendered, recipe);
        return registerSupplierArtworkAsset(rendered)
          .then(function (asset) {
            if (asset) {
              setNote("Supplier PNG exported and uploaded at " + rendered.size.w + " x " + rendered.size.h + "px.", "success");
              return saveCurrentRecipe().then(function () { return asset; });
            }
            setNote("Supplier PNG exported at " + rendered.size.w + " x " + rendered.size.h + "px. API upload is not configured.", "success");
            return null;
          })
          .catch(function () {
            setNote("Supplier PNG downloaded, but upload to production assets failed.", "error");
            return null;
          });
      });
    }

    function ensureSupplierArtworkAsset() {
      if (!assetUploadDataUrlApiUrl() && !assetRegisterApiUrl()) {
        return Promise.resolve(null);
      }
      if (designState.supplierArtworkAsset && designState.supplierArtworkAsset.printUrl) {
        return Promise.resolve(designState.supplierArtworkAsset);
      }
      setNote("Preparing supplier PNG for production...", "info");
      return renderSupplierArtworkPngBlob()
        .then(registerSupplierArtworkAsset)
        .then(function (asset) {
          if (!asset) throw new Error("Supplier artwork asset was not created");
          return asset;
        });
    }

    function attachWatermarkedPreview(recipe) {
      var svg = buildWatermarkedPreview(recipe);
      var dataUrl = svgDataUrl(svg);
      var key = "musemadePreview:" + recipe.designId;
      try {
        window.localStorage.setItem(key, dataUrl);
      } catch (error) {
        root.setAttribute("data-mm-preview-storage", "failed");
      }
      recipe.previewUrl = "localStorage:" + key;
      recipe.preview = {
        kind: "watermarked-low-res-svg",
        watermarked: true,
        printable: false,
        storageKey: key,
      };
      root.setAttribute("data-mm-preview-ready", "true");
      root.setAttribute("data-mm-preview-watermarked", "true");
      return dataUrl;
    }

    function downloadWatermarkedPreview(recipe) {
      var key = recipe.preview && recipe.preview.storageKey ? recipe.preview.storageKey : "musemadePreview:" + recipe.designId;
      var dataUrl = window.localStorage.getItem(key);
      if (!dataUrl) dataUrl = attachWatermarkedPreview(recipe);
      var link = document.createElement("a");
      link.href = dataUrl;
      link.download = recipe.designId + "-musemade-preview.svg";
      document.body.appendChild(link);
      link.click();
      link.remove();
    }

    function normalizeRecipeApiUrl(value) {
      var url = (value || "").trim();
      if (!url) return "";
      url = url.replace(/\/+$/, "");
      if (/\/api\/design-recipes$/i.test(url)) return url;
      return url + "/api/design-recipes";
    }

    function recipeApiSource() {
      if (recipeApiOverride) return "query";
      return (root.getAttribute("data-mm-recipe-api-url") || "").trim() ? "theme" : "local";
    }

    function recipeApiUrl() {
      return normalizeRecipeApiUrl(recipeApiOverride || root.getAttribute("data-mm-recipe-api-url"));
    }

    function studioSessionId() {
      var key = "musemadeStudioSession:v1";
      try {
        var existing = window.localStorage.getItem(key);
        if (existing) return existing;
        var generated = "mm-session-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 12);
        window.localStorage.setItem(key, generated);
        return generated;
      } catch (error) {
        return "mm-session-memory-" + Date.now().toString(36);
      }
    }

    function apiHeaders(extra) {
      return Object.assign({
        "Content-Type": "application/json",
        "X-MuseMade-Session": studioSessionId(),
      }, extra || {});
    }

    function assetApiUrl() {
      var url = recipeApiUrl();
      if (!url) return "";
      return url.replace(/\/api\/design-recipes\/?$/, "/api/assets/local-placeholder");
    }

    function assetRegisterApiUrl() {
      var url = recipeApiUrl();
      if (!url) return "";
      return url.replace(/\/api\/design-recipes\/?$/, "/api/assets");
    }

    function assetUploadDataUrlApiUrl() {
      var url = recipeApiUrl();
      if (!url) return "";
      return url.replace(/\/api\/design-recipes\/?$/, "/api/assets/upload-data-url");
    }

    function assetPresignApiUrl() {
      var url = recipeApiUrl();
      if (!url) return "";
      return url.replace(/\/api\/design-recipes\/?$/, "/api/assets/presign");
    }

    function assetCompleteUploadApiUrl(assetId) {
      var url = assetRegisterApiUrl();
      if (!url || !assetId) return "";
      return url.replace(/\/api\/assets\/?$/, "/api/assets/" + encodeURIComponent(assetId) + "/complete-upload");
    }

    function aiAssetJobApiUrl() {
      var url = recipeApiUrl();
      if (!url) return "";
      return url.replace(/\/api\/design-recipes\/?$/, "/api/assets/ai-job");
    }

    function assetCacheKey(layer) {
      return [designState.id || "draft", layer.id, designState.photoName || "placeholder", layer.crop || ""].join(":");
    }

    function normalizeAssetForRecipe(asset) {
      if (!asset) return null;
      return {
        assetId: asset.id || asset.assetId,
        id: asset.id || asset.assetId,
        sessionId: asset.sessionId || asset.session_id || null,
        kind: asset.kind,
        scope: asset.scope,
        source: asset.source,
        status: asset.status,
        parentAssetId: asset.parentAssetId || null,
        previewUrl: asset.previewUrl,
        printUrl: asset.printUrl,
        hasAlpha: asset.hasAlpha,
        width: asset.width,
        height: asset.height,
        pipeline: asset.pipeline || null,
        meta: asset.meta,
      };
    }

    function uploadedPhotoAssetId(file) {
      if (!designState.id) designState.id = makeDesignId();
      var fileKey = [file.name, file.size, file.lastModified || Date.now()].join("-");
      return ("upload-" + designState.id + "-" + fileKey).toLowerCase().replace(/[^a-z0-9_.:-]+/g, "-").slice(0, 110);
    }

    function uploadedPhotoExt(file) {
      var type = String((file && file.type) || "").toLowerCase();
      if (type === "image/jpeg") return "jpg";
      if (type === "image/webp") return "webp";
      if (type === "image/png") return "png";
      var match = String((file && file.name) || "").toLowerCase().match(/\.([a-z0-9]+)$/);
      return match && /^(png|jpe?g|webp)$/.test(match[1]) ? match[1].replace("jpeg", "jpg") : "png";
    }

    function postUploadedPhotoDataUrl(file, dataUrl, assetId, cacheKey) {
      var url = assetUploadDataUrlApiUrl() || assetRegisterApiUrl();
      if (!url) return Promise.resolve(null);
      return fetch(url, {
        method: "POST",
        headers: apiHeaders(),
        body: JSON.stringify({
          allowOverwrite: true,
          sessionId: studioSessionId(),
          dataUrl: dataUrl,
          fileName: file.name,
          asset: {
            id: assetId,
            sessionId: studioSessionId(),
            path: designState.path,
            pathVersion: designState.pathVersion,
            kind: "subject",
            scope: "user",
            source: "uploaded",
            status: "ready",
            hasAlpha: true,
            width: 2400,
            height: 2400,
            meta: {
              source: "studio-upload",
              designId: designState.id,
              fileName: file.name,
              fileSize: file.size,
              fileType: file.type || "",
              lastModified: file.lastModified || null,
              note: "Uploaded through Studio and stored by the MuseMade asset API.",
            },
          },
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Uploaded asset registration failed");
          return response.json();
        })
        .then(function (payload) {
          var normalized = normalizeAssetForRecipe(payload && payload.asset);
          if (!normalized) throw new Error("Missing uploaded asset payload");
          assetCache[cacheKey] = normalized;
          designState.photoAsset = normalized;
          root.setAttribute("data-mm-photo-asset-id", normalized.assetId || "");
          root.setAttribute("data-mm-photo-asset-status", normalized.status || "ready");
          syncAssetControls();
          return normalized;
        });
    }

    function putPresignedObject(url, blob, headers) {
      if (!url || !blob) return Promise.resolve();
      return fetch(url, {
        method: "PUT",
        headers: headers || {},
        body: blob,
      }).then(function (response) {
        if (!response.ok) throw new Error("Presigned upload failed");
      });
    }

    function registerPresignedPhotoAsset(file, dataUrl, assetId, cacheKey) {
      var presignUrl = assetPresignApiUrl();
      var registerUrl = assetRegisterApiUrl();
      if (!presignUrl || !registerUrl || !dataUrl) return Promise.resolve(null);
      return fetch(presignUrl, {
        method: "POST",
        headers: apiHeaders(),
        body: JSON.stringify({
          sessionId: studioSessionId(),
          id: assetId,
          kind: "subject",
          path: designState.path,
          pathVersion: designState.pathVersion,
          ext: uploadedPhotoExt(file),
          contentType: file.type || "image/png",
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Presign request failed");
          return response.json();
        })
        .then(function (payload) {
          var plan = payload && payload.presign;
          var upload = plan && plan.upload;
          if (!plan || plan.storageProvider !== "s3" || !upload || !upload.previewPutUrl || !upload.printPutUrl) {
            return null;
          }
          root.setAttribute("data-mm-photo-asset-status", "uploading");
          syncAssetControls();
          return fetch(dataUrl)
            .then(function (response) {
              return response.blob();
            })
            .then(function (blob) {
              return Promise.all([
                putPresignedObject(upload.previewPutUrl, blob, upload.headers),
                putPresignedObject(upload.printPutUrl, blob, upload.headers),
              ]);
            })
            .then(function () {
              return fetch(registerUrl, {
                method: "POST",
                headers: apiHeaders(),
                body: JSON.stringify(plan.registerPayload || {}),
              });
            })
            .then(function (response) {
              if (!response.ok) throw new Error("Presigned asset registration failed");
              return fetch(assetCompleteUploadApiUrl(assetId), {
                method: "POST",
                headers: apiHeaders(),
                body: JSON.stringify({
                  sessionId: studioSessionId(),
                  completedBy: "studio-browser",
                  byteLength: file.size || null,
                }),
              });
            })
            .then(function (response) {
              if (!response.ok) throw new Error("Presigned asset completion failed");
              return response.json();
            })
            .then(function (payload) {
              var normalized = normalizeAssetForRecipe(payload && payload.asset);
              if (!normalized) throw new Error("Missing completed asset payload");
              assetCache[cacheKey] = normalized;
              designState.photoAsset = normalized;
              root.setAttribute("data-mm-photo-asset-id", normalized.assetId || "");
              root.setAttribute("data-mm-photo-asset-status", normalized.status || "ready");
              syncAssetControls();
              return normalized;
            });
        });
    }

    function registerUploadedPhotoAsset(file, dataUrl) {
      if (!file || !dataUrl || !assetRegisterApiUrl()) return Promise.resolve(null);
      var assetId = uploadedPhotoAssetId(file);
      var cacheKey = "uploaded:" + assetId;
      if (assetCache[cacheKey]) return Promise.resolve(assetCache[cacheKey]);
      root.setAttribute("data-mm-photo-asset-status", "registering");
      syncAssetControls();
      return registerPresignedPhotoAsset(file, dataUrl, assetId, cacheKey)
        .then(function (asset) {
          if (asset) return asset;
          return postUploadedPhotoDataUrl(file, dataUrl, assetId, cacheKey);
        })
        .catch(function () {
          return postUploadedPhotoDataUrl(file, dataUrl, assetId, cacheKey);
        });
    }

    function requestAiAssetJob(action) {
      var url = aiAssetJobApiUrl();
      if (!url) {
        setNote("AI actions need the MuseMade API URL first.", "error");
        root.setAttribute("data-mm-ai-job-status", "missing-api");
        syncAssetControls();
        return Promise.resolve(null);
      }
      if (!designState.photoAsset || !designState.photoAsset.assetId) {
        setNote("Upload a photo and wait for asset registration before starting AI.", "error");
        root.setAttribute("data-mm-ai-job-status", "missing-parent-asset");
        syncAssetControls();
        return Promise.resolve(null);
      }
      var source = action === "style" ? "ai_style_transfer" : "ai_cutout";
      var style = action === "style" ? "soft-atelier-poster" : "clean-cutout";
      root.setAttribute("data-mm-ai-job-status", "requesting");
      root.setAttribute("data-mm-ai-job-source", source);
      syncAssetControls();
      setNote(action === "style" ? "Starting AI style-transfer job..." : "Starting AI cutout job...", "info");
      return fetch(url, {
        method: "POST",
        headers: apiHeaders(),
        body: JSON.stringify({
          sessionId: studioSessionId(),
          task: {
            source: source,
            kind: "subject",
            parentAssetId: designState.photoAsset.assetId,
            provider: "omni-placeholder",
            style: style,
            width: designState.photoAsset.width || 2400,
            height: designState.photoAsset.height || 2400,
            meta: {
              designId: designState.id || "",
              photoName: designState.photoName || "",
              requestedFrom: "shopify-studio",
            },
          },
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("AI asset job failed");
          return response.json();
        })
        .then(function (payload) {
          var asset = normalizeAssetForRecipe(payload && payload.asset);
          if (!asset) throw new Error("Missing AI asset payload");
          designState.pendingAiAsset = asset;
          root.setAttribute("data-mm-ai-job-status", payload.job && payload.job.status ? payload.job.status : "processing");
          root.setAttribute("data-mm-ai-job-id", payload.job && payload.job.id ? payload.job.id : "");
          root.setAttribute("data-mm-ai-asset-id", asset.assetId || "");
          syncAssetControls();
          pushHistory();
          setNote("AI job created. It is tracked as a processing asset and will become usable when completed.", "success");
          return payload;
        })
        .catch(function (error) {
          root.setAttribute("data-mm-ai-job-status", "failed");
          syncAssetControls();
          setNote(error && error.message ? error.message : "AI job could not be started.", "error");
          return null;
        });
    }

    function refreshPendingAiAsset() {
      var pending = designState.pendingAiAsset;
      if (!pending || !pending.assetId) {
        setNote("No AI job is waiting yet. Start AI cutout or style transfer first.", "error");
        root.setAttribute("data-mm-ai-job-status", "missing-pending-asset");
        syncAssetControls();
        return Promise.resolve(null);
      }
      var url = assetRegisterApiUrl();
      if (!url) {
        setNote("AI refresh needs the MuseMade API URL first.", "error");
        root.setAttribute("data-mm-ai-job-status", "missing-api");
        syncAssetControls();
        return Promise.resolve(null);
      }
      root.setAttribute("data-mm-ai-job-status", "refreshing");
      syncAssetControls();
      return fetch(url.replace(/\/api\/assets\/?$/, "/api/assets/" + encodeURIComponent(pending.assetId)), {
        headers: apiHeaders(),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("AI asset lookup failed");
          return response.json();
        })
        .then(function (payload) {
          var asset = normalizeAssetForRecipe(payload && payload.asset);
          if (!asset) throw new Error("Missing AI asset payload");
          designState.pendingAiAsset = asset;
          root.setAttribute("data-mm-ai-asset-id", asset.assetId || "");
          root.setAttribute("data-mm-ai-job-status", asset.status || "processing");
          if (asset.status === "ready") {
            designState.photoAsset = asset;
            root.setAttribute("data-mm-photo-asset-id", asset.assetId || "");
            root.setAttribute("data-mm-photo-asset-status", "ready");
            syncAssetControls();
            pushHistory();
            setNote("AI result is ready and now replaces the photo source for all photo layers.", "success");
            return asset;
          }
          setNote("AI result is still " + (asset.status || "processing") + ". Try refreshing again later.", "info");
          syncAssetControls();
          persistDraft();
          return asset;
        })
        .catch(function (error) {
          root.setAttribute("data-mm-ai-job-status", "refresh-failed");
          syncAssetControls();
          setNote(error && error.message ? error.message : "AI result could not be refreshed.", "error");
          return null;
        });
    }

    function createPlaceholderAsset(layer) {
      var url = assetApiUrl();
      if (!url || layer.type !== "photo") return Promise.resolve(null);
      var cacheKey = assetCacheKey(layer);
      if (assetCache[cacheKey]) return Promise.resolve(assetCache[cacheKey]);
      return fetch(url, {
        method: "POST",
        headers: apiHeaders(),
        body: JSON.stringify({
          sessionId: studioSessionId(),
          kind: "subject",
          label: layer.name || "Photo cutout",
          path: designState.path,
          pathVersion: designState.pathVersion,
          width: 2400,
          height: 2400,
          meta: {
            designId: designState.id,
            layerId: layer.id,
            photoName: designState.photoName || "",
            source: "studio-placeholder",
          },
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Asset placeholder failed");
          return response.json();
        })
        .then(function (payload) {
          var asset = payload && payload.asset;
          if (!asset) throw new Error("Missing asset payload");
          assetCache[cacheKey] = normalizeAssetForRecipe(asset);
          return assetCache[cacheKey];
        });
    }

    function prepareRecipeAssets() {
      var url = assetApiUrl();
      var resolved = {};
      if (!url) return Promise.resolve(resolved);
      var photoLayers = designState.layers.filter(function (layer) {
        return layer.type === "photo";
      });
      return Promise.all(photoLayers.map(function (layer) {
        if (designState.photoAsset && designState.photoAsset.status === "ready") {
          resolved[layer.id] = designState.photoAsset;
          return Promise.resolve();
        }
        return createPlaceholderAsset(layer).then(function (asset) {
          if (asset) resolved[layer.id] = asset;
        });
      })).then(function () {
        return resolved;
      });
    }

    function applyRecipeSummary(recipe, status) {
      window.localStorage.setItem("musemadeRecipe:" + designState.id, JSON.stringify(recipe));
      window.localStorage.setItem("musemadeDesign:" + designState.id, JSON.stringify(designState));
      window.localStorage.setItem("musemadeLatestDesign", designState.id);
      window.localStorage.setItem("musemadeLatestRecipe", designState.id);
      window.__musemadeLastRecipe = recipe;
      root.setAttribute("data-mm-recipe-schema", recipe.schemaVersion);
      root.setAttribute("data-mm-recipe-id", recipe.designId);
      root.setAttribute("data-mm-recipe-path", recipe.pathVersion);
      root.setAttribute("data-mm-recipe-layers", String(recipe.layers.length));
      root.setAttribute("data-mm-recipe-storage", status || "local");
      root.setAttribute("data-mm-recipe-api-source", recipeApiSource());
      root.setAttribute("data-mm-recipe-api-active", recipeApiUrl() ? "true" : "false");
    }

    function saveCurrentRecipeLocal(resolvedAssets) {
      if (!designState.id) designState.id = makeDesignId();
      designState.savedAt = new Date().toISOString();
      var recipe = buildDesignRecipe(resolvedAssets);
      recipe.designId = designState.id;
      attachWatermarkedPreview(recipe);
      applyRecipeSummary(recipe, "local");
      return recipe;
    }

    function postRecipe(recipe) {
      var url = recipeApiUrl();
      if (!url) return Promise.resolve({ stored: false, designId: recipe.designId });
      return fetch(url, {
        method: "POST",
        headers: apiHeaders(),
        body: JSON.stringify({ sessionId: studioSessionId(), recipe: recipe }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Recipe API failed");
          return response.json();
        })
        .then(function (payload) {
          if (payload && payload.designId && payload.designId !== designState.id) {
            window.localStorage.removeItem("musemadeRecipe:" + designState.id);
            window.localStorage.removeItem("musemadeDesign:" + designState.id);
            designState.id = payload.designId;
            recipe.designId = payload.designId;
          }
          recipe.server = {
            stored: true,
            status: payload.status || "draft",
            savedAt: payload.savedAt || new Date().toISOString(),
          };
          applyRecipeSummary(recipe, "api");
          return payload;
        });
    }

    function saveCurrentRecipe() {
      var validation = validateDraft();
      applyValidationSummary(validation);
      if (!validation.ok) {
        return Promise.reject(Object.assign(new Error(validation.errors[0] || "Design needs review."), { validation: validation }));
      }
      if (!designState.id) designState.id = makeDesignId();
      return prepareRecipeAssets().then(function (resolvedAssets) {
        var recipe = saveCurrentRecipeLocal(resolvedAssets);
        return postRecipe(recipe).then(function () {
          return recipe;
        });
      });
    }

    function normalizeOptionText(value) {
      return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
    }

    function variantSearchText(variant) {
      return normalizeOptionText([
        variant && variant.title,
        variant && variant.option1,
        variant && variant.option2,
        variant && variant.option3,
        variant && variant.public_title,
        variant && variant.sku,
      ].filter(Boolean).join(" "));
    }

    function variantAvailable(variant) {
      return !variant || variant.available !== false;
    }

    function pickCartVariant(product) {
      var variants = product && Array.isArray(product.variants) ? product.variants : [];
      if (!variants.length) return null;
      var modelNeedle = normalizeOptionText(designState.model);
      var caseNeedle = normalizeOptionText(designState.caseType);
      var exact = variants.find(function (variant) {
        var text = variantSearchText(variant);
        return variantAvailable(variant) && text.indexOf(modelNeedle) !== -1 && text.indexOf(caseNeedle) !== -1;
      });
      if (exact) return exact;
      var modelOnly = variants.find(function (variant) {
        return variantAvailable(variant) && variantSearchText(variant).indexOf(modelNeedle) !== -1;
      });
      if (modelOnly) return modelOnly;
      var caseOnly = variants.find(function (variant) {
        return variantAvailable(variant) && variantSearchText(variant).indexOf(caseNeedle) !== -1;
      });
      if (caseOnly) return caseOnly;
      return variants.find(variantAvailable) || variants[0];
    }

    function cartProperties(recipe, variant) {
      var validation = validateDraft();
      var visiblePreview = recipe.preview && recipe.preview.watermarked ? "Watermarked preview saved in MuseMade Studio" : "Preview saved in MuseMade Studio";
      return {
        _design_id: designState.id,
        _path: designState.path,
        _path_version: designState.pathVersion,
        _recipe_schema: recipe.schemaVersion,
        _phone_model_template: modelTemplateId(),
        _case_type: designState.caseType,
        _preview_url: recipe.previewUrl || "",
        _preview_kind: recipe.preview && recipe.preview.kind ? recipe.preview.kind : "",
        _supplier_artwork_format: recipe.supplierArtwork && recipe.supplierArtwork.format ? recipe.supplierArtwork.format : "png",
        _supplier_artwork_size: recipe.supplierArtwork ? recipe.supplierArtwork.w + "x" + recipe.supplierArtwork.h : "",
        _supplier_artwork_asset_id: recipe.supplierArtwork && recipe.supplierArtwork.assetId ? recipe.supplierArtwork.assetId : "",
        _supplier_artwork_url: recipe.supplierArtwork && recipe.supplierArtwork.printUrl ? recipe.supplierArtwork.printUrl : "",
        _validation_errors: String(validation.errors.length),
        _validation_warnings: String(validation.warnings.length),
        _variant_title: variant && variant.title ? variant.title : "",
        "Design ID": designState.id,
        "Preview": visiblePreview,
        "Custom type": "Pet portrait phone case",
        "Case type": designState.caseType,
        "Phone model": designState.model,
        "Supplier PNG": recipe.supplierArtwork ? recipe.supplierArtwork.w + " x " + recipe.supplierArtwork.h + "px" : "",
        "Template": templates[designState.template].label,
        "Layer count": String(designState.layers.length),
      };
    }

    function cloneLayer(layer) {
      layerSeed += 1;
      var copy = Object.assign({}, layer);
      copy.id = "layer-" + layerSeed;
      copy.z = layerSeed;
      copy.scale = copy.scale || 1;
      copy.rotate = copy.rotate || 0;
      return copy;
    }

    function selectedLayer() {
      return designState.layers.find(function (layer) {
        return layer.id === designState.selectedId;
      });
    }

    function layerContent(layer) {
      if (layer.type === "text") return layer.text || "Name";
      if (layer.type === "photo") {
        if (designState.photoData) {
          return '<img src="' + designState.photoData + '" alt="">';
        }
        return '<span class="mm-fake-cat"><span></span></span>';
      }
      if (layer.sticker === "bear") return '<span class="mm-sticker-bear"></span>';
      if (layer.sticker === "sparkle") return '<span class="mm-sticker-sparkle"></span>';
      if (layer.sticker === "strawberry") return '<span class="mm-sticker-strawberry"></span>';
      if (layer.sticker === "heart") return '<span class="mm-sticker-heart"></span>';
      return "";
    }

    function renderSurface() {
      if (!surface) return;
      surface.querySelectorAll("[data-mm-layer]").forEach(function (node) {
        node.remove();
      });
      designState.layers
        .slice()
        .sort(function (a, b) {
          return a.z - b.z;
        })
        .forEach(function (layer) {
          var node = document.createElement("button");
          node.type = "button";
          node.className = "mm-edit-layer";
          node.setAttribute("data-mm-layer", layer.id);
          node.setAttribute("data-type", layer.type);
          if (layer.crop) node.setAttribute("data-crop", layer.crop);
          if (layer.shape) node.setAttribute("data-shape", layer.shape);
          if (layer.sticker) node.setAttribute("data-sticker", layer.sticker);
          node.classList.toggle("is-selected", layer.id === designState.selectedId);
          node.style.left = layer.x + "%";
          node.style.top = layer.y + "%";
          node.style.width = layer.w + "%";
          node.style.height = layer.h + "%";
          node.style.zIndex = String(layer.z);
          node.style.setProperty("--mm-layer-rotate", layer.rotate + "deg");
          node.style.setProperty("--mm-layer-scale", layer.scale);
          node.innerHTML = layerContent(layer);
          surface.appendChild(node);
        });
    }

    function clampLayerPosition(layer) {
      var scale = layer.scale || 1;
      var halfW = Math.min(42, ((layer.w || 10) * scale) / 2);
      var halfH = Math.min(42, ((layer.h || 10) * scale) / 2);
      layer.x = Math.max(halfW + 2, Math.min(98 - halfW, layer.x));
      layer.y = Math.max(halfH + 2, Math.min(98 - halfH, layer.y));
      avoidCameraKeepout(layer, halfW, halfH);
    }

    function percentNumber(value, fallback) {
      var number = parseFloat(value);
      return Number.isFinite(number) ? number : fallback;
    }

    function avoidCameraKeepout(layer, halfW, halfH) {
      var spec = activeModelSpec;
      if (!spec) return;
      var left = percentNumber(spec.keepoutLeft, 0);
      var top = percentNumber(spec.keepoutTop, 0);
      var width = percentNumber(spec.keepoutWidth, 0);
      var height = percentNumber(spec.keepoutHeight, 0);
      var right = left + width;
      var bottom = top + height;
      var overlapsX = layer.x + halfW > left && layer.x - halfW < right;
      var overlapsY = layer.y + halfH > top && layer.y - halfH < bottom;
      if (!overlapsX || !overlapsY) return;
      var pushRight = right + halfW + 2;
      var pushDown = bottom + halfH + 2;
      if (pushRight <= 98 - halfW && pushRight - layer.x < pushDown - layer.y) {
        layer.x = pushRight;
      } else {
        layer.y = Math.min(98 - halfH, pushDown);
      }
    }

    function renderLayerList() {
      if (!layerList) return;
      layerList.innerHTML = "";
      designState.layers
        .slice()
        .sort(function (a, b) {
          return b.z - a.z;
        })
        .forEach(function (layer) {
          var button = document.createElement("button");
          button.type = "button";
          button.className = "mm-layer-row";
          button.classList.toggle("is-active", layer.id === designState.selectedId);
          button.setAttribute("data-mm-select-layer", layer.id);
          button.innerHTML = '<span>' + layer.name + '</span><small>' + layer.type + '</small>';
          layerList.appendChild(button);
        });
    }

    function syncControls() {
      var layer = selectedLayer();
      var isText = layer && layer.type === "text";
      if (selectedCopy) {
        selectedCopy.textContent = layer ? "Editing: " + layer.name : "Select any element on the case to move, scale, rotate, duplicate, or delete it.";
      }
      if (textInput) {
        textInput.value = isText ? layer.text || "" : "";
        textInput.disabled = !isText;
      }
      if (scaleInput) scaleInput.value = layer ? Math.round((layer.scale || 1) * 100) : 100;
      if (rotateInput) rotateInput.value = layer ? layer.rotate || 0 : 0;
      if (designIdEl) designIdEl.textContent = designState.id || "Not saved";
    }

    function renderAll() {
      var template = templates[designState.template];
      if (templateLabel) templateLabel.textContent = template.label;
      if (styleSummary) styleSummary.textContent = template.label;
      syncModelText();
      syncSupplierArtworkText();
      root.querySelectorAll("[data-mm-template]").forEach(function (button) {
        button.classList.toggle("is-active", button.getAttribute("data-mm-template") === designState.template);
      });
      renderSurface();
      renderLayerList();
      syncControls();
      syncAssetControls();
      updateHistoryButtons();
    }

    function selectLayer(id) {
      designState.selectedId = id;
      renderAll();
    }

    function loadTemplate(key, options) {
      var template = templates[key] || templates["kawaii-collage"];
      designState.template = key;
      designState.layers = template.layers.map(cloneLayer);
      designState.layers.forEach(clampLayerPosition);
      designState.selectedId = designState.layers[designState.layers.length - 1].id;
      designState.id = "";
      renderAll();
      setNote("Preset loaded. Drag any element directly on the case.", "success");
      if (!options || !options.skipHistory) pushHistory();
    }

    function addLayer(kind) {
      var base = {
        photo: { type: "photo", name: "Photo cutout", crop: "cutout", x: 54, y: 48, w: 36, h: 28, scale: 1, rotate: 0 },
        circle: { type: "shape", name: "Color circle", shape: "record", x: 50, y: 52, w: 46, h: 28, scale: 1, rotate: 0 },
        heart: { type: "sticker", name: "Heart sticker", sticker: "heart", x: 66, y: 64, w: 22, h: 18, scale: 1, rotate: 0 },
        sparkle: { type: "sticker", name: "Sparkles", sticker: "sparkle", x: 78, y: 32, w: 15, h: 16, scale: 1, rotate: 0 },
        bear: { type: "sticker", name: "Bear sticker", sticker: "bear", x: 25, y: 36, w: 16, h: 13, scale: 1, rotate: -8 },
        text: { type: "text", name: "Name text", text: "MuseMade", x: 50, y: 60, w: 44, h: 9, scale: 1, rotate: -4 },
      }[kind];
      if (!base) return;
        var layer = cloneLayer(base);
        clampLayerPosition(layer);
        designState.layers.push(layer);
        selectLayer(layer.id);
      setNote("Layer added. Drag it on the case or tune it on the right.", "success");
      pushHistory();
    }

    function moveSelected(deltaZ) {
      var layer = selectedLayer();
      if (!layer) return;
      layer.z = Math.max(1, layer.z + deltaZ);
      designState.layers
        .slice()
        .sort(function (a, b) {
          return a.z - b.z;
        })
        .forEach(function (item, index) {
          item.z = index + 1;
        });
      if (deltaZ > 0) layer.z = designState.layers.length;
      if (deltaZ < 0) layer.z = 1;
      renderAll();
      pushHistory();
    }

    root.addEventListener("click", function (event) {
      var templateButton = event.target.closest("[data-mm-template]");
      var addButton = event.target.closest("[data-mm-add-layer]");
      var aiButton = event.target.closest("[data-mm-ai-action]");
      var aiRefreshButton = event.target.closest("[data-mm-ai-refresh]");
      var layerButton = event.target.closest("[data-mm-select-layer]");
      var layerNode = event.target.closest("[data-mm-layer]");
      if (templateButton) loadTemplate(templateButton.getAttribute("data-mm-template"));
      if (addButton) addLayer(addButton.getAttribute("data-mm-add-layer"));
      if (aiButton) requestAiAssetJob(aiButton.getAttribute("data-mm-ai-action"));
      if (aiRefreshButton) refreshPendingAiAsset();
      if (layerButton) selectLayer(layerButton.getAttribute("data-mm-select-layer"));
      if (layerNode) selectLayer(layerNode.getAttribute("data-mm-layer"));
    });

    if (surface) {
      surface.addEventListener("pointerdown", function (event) {
        var node = event.target.closest("[data-mm-layer]");
        if (!node) return;
        var layer = designState.layers.find(function (item) {
          return item.id === node.getAttribute("data-mm-layer");
        });
        if (!layer) return;
        selectLayer(layer.id);
        var rect = surface.getBoundingClientRect();
        dragState = {
          id: layer.id,
          startX: event.clientX,
          startY: event.clientY,
          layerX: layer.x,
          layerY: layer.y,
          width: rect.width,
          height: rect.height,
        };
        node.setPointerCapture(event.pointerId);
        event.preventDefault();
      });

      surface.addEventListener("pointermove", function (event) {
        if (!dragState) return;
        var layer = designState.layers.find(function (item) {
          return item.id === dragState.id;
        });
        if (!layer) return;
        layer.x = dragState.layerX + ((event.clientX - dragState.startX) / dragState.width) * 100;
        layer.y = dragState.layerY + ((event.clientY - dragState.startY) / dragState.height) * 100;
        clampLayerPosition(layer);
        renderSurface();
      });

      surface.addEventListener("pointerup", function () {
        if (dragState) {
          dragState = null;
          renderAll();
          pushHistory();
        }
      });

      surface.addEventListener("pointercancel", function () {
        if (dragState) {
          dragState = null;
          renderAll();
          pushHistory();
        }
      });
    }

    if (photoInput) {
      photoInput.addEventListener("change", function (event) {
        var file = event.target.files && event.target.files[0];
        if (!file) return;
        var reader = new FileReader();
        reader.onload = function () {
          designState.photoName = file.name;
          designState.photoData = String(reader.result || "");
          designState.photoAsset = null;
          designState.pendingAiAsset = null;
          root.setAttribute("data-mm-photo-asset-status", "local");
          root.setAttribute("data-mm-photo-asset-id", "");
          root.setAttribute("data-mm-ai-job-status", "idle");
          root.setAttribute("data-mm-ai-job-id", "");
          root.setAttribute("data-mm-ai-asset-id", "");
          renderAll();
          pushHistory();
          setNote(assetRegisterApiUrl() ? "Photo loaded. Registering it as a production asset..." : "Photo loaded. All photo layers now use this source.", "success");
          registerUploadedPhotoAsset(file, designState.photoData)
            .then(function (asset) {
              if (!asset) return;
              pushHistory();
              setNote("Photo asset registered. It will be referenced by every photo layer.", "success");
            })
            .catch(function () {
              root.setAttribute("data-mm-photo-asset-status", "failed");
              syncAssetControls();
              setNote("Photo loaded for editing. Asset registration failed, so save will use a placeholder.", "error");
            });
        };
        reader.readAsDataURL(file);
      });
    }

    if (modelSelect) {
      modelSelect.value = designState.model;
      modelSelect.addEventListener("change", function () {
        applyModelSpec(modelSelect.value);
        setNote("Model changed to " + designState.model + ". Case shape and camera area updated.", "success");
        pushHistory();
      });
    }

    if (textInput) {
      textInput.addEventListener("input", function () {
        var layer = selectedLayer();
        if (!layer || layer.type !== "text") return;
        layer.text = textInput.value || "Name";
        renderAll();
        persistDraft();
      });
      textInput.addEventListener("change", function () {
        var layer = selectedLayer();
        if (!layer || layer.type !== "text") return;
        pushHistory();
      });
    }

    if (scaleInput) {
      scaleInput.addEventListener("input", function () {
        var layer = selectedLayer();
        if (!layer) return;
        layer.scale = Math.max(0.4, Math.min(2.2, Number(scaleInput.value) / 100 || 1));
        clampLayerPosition(layer);
        renderSurface();
        persistDraft();
      });
      scaleInput.addEventListener("change", function () {
        var layer = selectedLayer();
        if (!layer) return;
        renderAll();
        pushHistory();
      });
    }

    if (rotateInput) {
      rotateInput.addEventListener("input", function () {
        var layer = selectedLayer();
        if (!layer) return;
        layer.rotate = Number(rotateInput.value) || 0;
        renderSurface();
        persistDraft();
      });
      rotateInput.addEventListener("change", function () {
        var layer = selectedLayer();
        if (!layer) return;
        renderAll();
        pushHistory();
      });
    }

    root.querySelector("[data-mm-undo-layer]")?.addEventListener("click", undoChange);
    root.querySelector("[data-mm-redo-layer]")?.addEventListener("click", redoChange);

    root.querySelector("[data-mm-center-layer]")?.addEventListener("click", function () {
      var layer = selectedLayer();
      if (!layer) return;
      layer.x = 50;
      layer.y = 50;
      renderAll();
      pushHistory();
    });

    root.querySelector("[data-mm-duplicate-layer]")?.addEventListener("click", function () {
      var layer = selectedLayer();
      if (!layer) return;
      var copy = cloneLayer(Object.assign({}, layer, { name: layer.name + " copy", x: layer.x + 5, y: layer.y + 5 }));
      designState.layers.push(copy);
      selectLayer(copy.id);
      pushHistory();
    });

    root.querySelector("[data-mm-delete-layer]")?.addEventListener("click", function () {
      var layer = selectedLayer();
      if (!layer) return;
      designState.layers = designState.layers.filter(function (item) {
        return item.id !== layer.id;
      });
      designState.selectedId = designState.layers.length ? designState.layers[designState.layers.length - 1].id : "";
      renderAll();
      pushHistory();
    });

    root.querySelector("[data-mm-layer-front]")?.addEventListener("click", function () {
      moveSelected(99);
    });

    root.querySelector("[data-mm-layer-back]")?.addEventListener("click", function () {
      moveSelected(-99);
    });

    root.querySelector("[data-mm-save-design]")?.addEventListener("click", function () {
      setNote(recipeApiUrl() ? "Saving recipe to MuseMade..." : "Saving recipe in this browser...", "info");
      saveCurrentRecipe()
        .then(function (recipe) {
          renderAll();
          var validation = validateDraft();
          var suffix = validation.warnings.length ? " Review edge placement before ordering." : " It is ready to attach to cart.";
          setNote("Recipe saved as " + recipe.designId + "." + suffix, "success");
        })
        .catch(function (error) {
          if (error && error.validation) {
            setNote(error.message, "error");
            return;
          }
          setNote("The browser copy is saved, but the recipe API did not respond.", "error");
        });
    });

    root.querySelector("[data-mm-export-supplier-png]")?.addEventListener("click", function () {
      setNote("Preparing supplier PNG...", "info");
      saveCurrentRecipe()
        .then(function (recipe) {
          return exportSupplierArtworkPng(recipe).then(function () {
            renderAll();
          });
        })
        .catch(function (error) {
          if (error && error.validation) {
            setNote(error.message, "error");
            return;
          }
          setNote("Could not export supplier PNG yet. Try saving the design again.", "error");
        });
    });

    root.querySelector("[data-mm-export-preview]")?.addEventListener("click", function () {
      setNote("Preparing a watermarked low-res preview...", "info");
      saveCurrentRecipe()
        .then(function (recipe) {
          downloadWatermarkedPreview(recipe);
          renderAll();
          setNote("Watermarked preview exported. The print file stays private.", "success");
        })
        .catch(function (error) {
          if (error && error.validation) {
            setNote(error.message, "error");
            return;
          }
          setNote("Could not export preview yet. Try saving the design again.", "error");
        });
    });

    if (addCart) {
      addCart.addEventListener("click", function () {
        var productUrl = addCart.getAttribute("data-product-url") || "/products/ai-pet-phone-case";
        var productJsonUrl = productUrl.replace(/\/$/, "") + ".js";
        var recipe;
        setNote("Preparing design recipe...", "info");
        saveCurrentRecipe()
          .then(function (savedRecipe) {
            recipe = savedRecipe;
            return ensureSupplierArtworkAsset();
          })
          .then(function () {
            return saveCurrentRecipe();
          })
          .then(function (savedRecipe) {
            recipe = savedRecipe;
            renderAll();
            setNote("Preparing cart item...", "info");
            return fetch(productJsonUrl);
          })
          .then(function (response) {
            if (!response.ok) throw new Error("Product lookup failed");
            return response.json();
          })
          .then(function (product) {
            var variant = pickCartVariant(product);
            if (!variant) throw new Error("No product variant found");
            return fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                id: variant.id,
                quantity: 1,
                properties: cartProperties(recipe, variant),
              }),
            });
          })
          .then(function (response) {
            if (!response.ok) throw new Error("Add to cart failed");
            return response.json();
          })
          .then(function () {
            setNote("Added to cart with design properties.", "success");
            window.location.href = "/cart";
          })
          .catch(function (error) {
            if (error && error.validation) {
              setNote(error.message, "error");
              return;
            }
            setNote("Could not prepare the production PNG or cart item. Save the design and try again.", "error");
          });
      });
    }

    applyModelSpec(model);
    if (restoreDraft()) {
      renderAll();
      resetHistory();
      setNote("Draft restored. You can keep editing or save it as a design.", "success");
    } else {
      loadTemplate("kawaii-collage", { skipHistory: true });
      resetHistory();
    }
  }

  document.querySelectorAll("[data-mm-phone-product]").forEach(initPhoneProduct);
  document.querySelectorAll("[data-mm-studio]").forEach(initStudio);
})();
